import { Component } from '@angular/core';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent {
  dataFAQ1 = [
    { question: 'support_questions.question_1.question', answer: 'support_questions.question_1.answer', expanded: false },
    { question: 'support_questions.question_2.question', answer: 'support_questions.question_2.answer', expanded: false },
    { question: 'support_questions.question_3.question', answer: 'support_questions.question_3.answer', expanded: false },
    { question: 'support_questions.question_4.question', answer: 'support_questions.question_4.answer', expanded: false },
    { question: 'support_questions.question_5.question', answer: 'support_questions.question_5.answer', expanded: false },
    { question: 'support_questions.question_6.question', answer: 'support_questions.question_6.answer', expanded: false },
  ];
  dataFAQ2 = [
    { question: 'support_questions.question_7.question', answer: 'support_questions.question_7.answer' , expanded: false},
    { question: 'support_questions.question_8.question', answer: 'support_questions.question_8.answer' , expanded: false},
    { question: 'support_questions.question_9.question', answer: 'support_questions.question_9.answer' , expanded: false},
    { question: 'support_questions.question_10.question', answer: 'support_questions.question_10.answer' , expanded: false},
    { question: 'support_questions.question_12.question', answer: 'support_questions.question_12.answer' , expanded: false},
    { question: 'support_questions.question_13.question', answer: 'support_questions.question_13.answer' , expanded: false},
  ]

  onToggle(itemGroup: 'dataFAQ1' | 'dataFAQ2', index: number): void {
    this.dataFAQ1.forEach((item, i) => item.expanded = itemGroup === 'dataFAQ1' && i === index);
    this.dataFAQ2.forEach((item, i) => item.expanded = itemGroup === 'dataFAQ2' && i === index);
  }
}
